module.exports = __webpack_public_path__ + "media/acuity/business_model-9e0d51af.svg";